import db_lib from 'xAppLib/libs/db_lib';
import game_players_model from './game_players_model.js';

const _FRDB_LOC = 'games_lgs';
const _FRST_LOC = 'game_plays';

const _MODEL_NAME = 'game_play_model';

const DEBUG = false;

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

export default class game_play_model extends db_lib {

	static get FRDB_LOC() { return _FRDB_LOC; }
	static get FRST_LOC() { return _FRST_LOC; }
	static get DET_FIELDS() { return _DET_FIELDS; }
	static get MODEL_NAME() { return _MODEL_NAME; }


// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

	static async play_start(game, gid, p) {

		DEBUG && console.log('game_play_model.play_start', game, gid, p)

		const gpid = await game_play_model.add_record(
					{
						game,
						gid,
						p,
						stat: 'open',
					},
					{
						timestamp: true,
						add_by: true,
					}
				)

		// Create marker doc for game access tracking and statistics
		if (app.user?.uid) {
			game_play_model.create_game_player_marker(gid);
		}

		return gpid
	}

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

	static async create_game_player_marker(gid) {

		DEBUG && console.log('game_play_model.create_game_player_marker', gid)

		game_players_model.create_marker(gid);

	}

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

	static async play_add_move(gpid, m) {

		DEBUG && console.log('game_play_model.play_add_move', gpid, m)

		game_play_model.insert_record(
					gpid,
					'mvs', 
					m, 
					{
						timestamp: true,
						add_by: true,
					}
				)

		if (m.i==1)
			game_play_model.update_record(
						gpid,
						{stat: 'guess'} 
					)

	}

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

	static async play_stat(gpid, s) {

		DEBUG && console.log('game_play_model.play_stat', gpid, s)

		await game_play_model.update_record(
					gpid,
					{stat: s}
				)

	}

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  


	static async load_game_plays(gid) {

		DEBUG && console.log('game_play_model.load_game_plays', gid)

		return await game_play_model.get_record( null, null, {fld: 'gid', fld_val:gid, add_id:'gpid', ord_by:'tm', ord_dir:'desc'} )

	}

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

	static async load_game_plays_stats(gid) {

		DEBUG && console.log('game_play_model.load_game_plays_stats', gid)

		const games = await game_play_model.get_record( null, null, {fld: 'gid', fld_val:gid, add_id:'gpid'} )

		const stats_count = games?.reduce((acc, curr) => {
			acc[curr.stat] = (acc[curr.stat] || 0) + 1;
			return acc;
		}, {});

		stats_count.tots = games?.length

		return stats_count

	}

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

	static async load_games_played_by_user() {

		DEBUG && console.log('game_play_model.load_games_played_by_user')

		return await game_play_model.get_record(
			null,
			null,
			{
				fld: 'by.u',
				fld_val: app.user?.uid,
				add_id: 'gpid',
				ord_by: 'tm',
				ord_dir: 'desc'
			}
		);
	}

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

}